module.exports = __webpack_public_path__ + "img/SETTING.871c619c.svg";